import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"
// import { compose } from "recompose"
// import withMobileDialog from "@material-ui/core/withMobileDialog"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import { Button, Box, Typography } from "@material-ui/core/"
import { closeDisconnectIntegrationsDialog } from "actions/disconnect-integrations-dialog"
import DialogsContainerDialog from "../DialogsContainer"
import { removeNetwork } from "actions/organization"
import { openSnackBar } from "actions/snack-bar"
import LoaderButton from "../../components/LoaderButton"

const DisconnectIntegrationsDialog = ({ classes }) => {
  const dispatch = useDispatch()
  const { open, data } = useSelector(state => ({
    open: state.disconnectIntegrationsDialog.open,
    data: state.disconnectIntegrationsDialog.data
  }))
  const [working, setWorking] = useState(false)

  const handleClose = () => {
    dispatch(closeDisconnectIntegrationsDialog())
  }

  const handleDisconnect = () => {
    setWorking(true)
    dispatch(removeNetwork(data))
      .then(res => {
        setWorking(false)
        handleClose()
        dispatch(openSnackBar({ message: `${data} has been disconnected.` }))
      })
      .catch(error => {
        setWorking(false)
        handleClose()
        dispatch(openSnackBar({ message: `Disconnect failed.` }))
      })
  }
  return (
    <DialogsContainerDialog
      open={open}
      handleClose={handleClose}
      title="Disconnect social media network?"
      content={
        <Typography variant="caption" className={classes.textExplanation}>
          This will disconnect this social media network. Are you sure you want
          to disconnect it?
        </Typography>
      }
      buttons={
        <Box display="flex">
          <Button
            variant="text"
            className={classes.cancelButton}
            onClick={handleClose}
          >
            cancel
          </Button>
          <LoaderButton
            classes={{ button: classes.disconnectButton }}
            onClick={handleDisconnect}
            working={working}
          >
            disconnect
          </LoaderButton>
        </Box>
      }
      fullScreen={false}
    />
  )
}

export default withStyles(styles)(DisconnectIntegrationsDialog)



// WEBPACK FOOTER //
// ./src/dialogs/DisconnectIntegrations/index.jsx